import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "@/redux/axios";

interface EvaluationDetailState {
  isFetchingDetails: boolean;
  evaluationDetails: any | null;
  error: string | null;
}

const initialState: EvaluationDetailState = {
  isFetchingDetails: false,
  evaluationDetails: null,
  error: null,
};

// Fetch evaluation details by ID
export const fetchEvaluationDetails = createAsyncThunk(
  "evaluationDetail/fetchEvaluationDetails",
  async (evaluationId: string, thunkAPI) => {
    try {
      console.log("🚀 Fetching evaluation details for ID:", evaluationId);
      const response = await axios.get(`/evaluation/${evaluationId}`);

      console.log("✅ Evaluation details response:", response.data);

      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (err: any) {
      console.error("❌ Error fetching evaluation details:", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(
        err.response.data || { message: "Failed to fetch evaluation details" }
      );
    }
  }
);

export const evaluationDetailSlice = createSlice({
  name: "evaluationDetail",
  initialState,
  reducers: {
    clearEvaluationDetails: (state) => {
      state.evaluationDetails = null;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Evaluation Details
      .addCase(fetchEvaluationDetails.pending, (state) => {
        state.isFetchingDetails = true;
        state.error = null;
      })
      .addCase(fetchEvaluationDetails.fulfilled, (state, action) => {
        state.isFetchingDetails = false;
        state.evaluationDetails = action.payload;
        state.error = null;
      })
      .addCase(fetchEvaluationDetails.rejected, (state, action: any) => {
        state.isFetchingDetails = false;
        state.evaluationDetails = null;
        state.error = action.payload?.message || "Failed to fetch evaluation details";
      });
  },
});

export const { clearEvaluationDetails, clearError } = evaluationDetailSlice.actions;

export const evaluationDetailSelector = (state: any) => state.evaluationDetail;

export const evaluationDetailReducer = evaluationDetailSlice.reducer;
export default evaluationDetailSlice.reducer;

